import React from "react";
import KpiStrip from "./KpiStrip";
import Tag from "./Tag";
import { dateTime } from "../format";
// import { getAllStoresHealth } from "../../../../../../../../Service/DashboardServices/FBAInventoryServices/inventoryAlertsService";

function HealthRows({ rows }) {
  return (
    <div className="ia-card ia-scroll">
      <table className="ia-table">
        <thead>
          <tr>
            <th>Store</th>
            <th>Last report</th>
            <th>Last live poll</th>
            <th>Authorisation</th>
            <th>APIs without access</th>
            <th>Issue</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.profileId} className={r.level === "u" ? "ia-row--urgent" : ""}>
              <td className="ia-strong">{r.store || r.profileId}</td>
              <td>{dateTime(r.lastReport)}</td>
              <td>{dateTime(r.lastLivePoll)}</td>
              <td className={r.authorisation && r.authorisation !== "Valid" ? "ia-text--crit ia-strong" : ""}>
                {r.authorisation || "—"}
              </td>
              <td>{r.notAuthorized && r.notAuthorized.length ? r.notAuthorized.join(", ") : "—"}</td>
              <td>{r.issue || <Tag level="ok">OK</Tag>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function SystemHealth({ data }) {
  // const [all, setAll] = useState(null);
  // const [loadingAll, setLoadingAll] = useState(false);
  // const [error, setError] = useState(null);
  const k = data.kpis;

  // const loadAll = async () => {
  //   setLoadingAll(true);
  //   setError(null);
  //   try {
  //     setAll(await getAllStoresHealth());
  //   } catch (e) {
  //     setError(e.message);
  //   } finally {
  //     setLoadingAll(false);
  //   }
  // };

  return (
    <div>
      <p className="ia-lead">Internal only. Problems here stop alerts from being accurate, so fix them before acting on alerts.</p>
      <KpiStrip
        items={[
          { label: "Stale data", value: k.staleData ? "Yes" : "No", sub: "No update in 24 h", level: k.staleData ? "crit" : "ok" },
          { label: "Authorisation", value: k.authorisationProblems ? "Failing" : "Valid", sub: "Seller token", level: k.authorisationProblems ? "crit" : "ok" },
          { label: "Report failures today", value: k.reportFailuresToday, sub: "Retried automatically", level: k.reportFailuresToday ? "warn" : null },
          { label: "Live vs report gaps", value: k.liveVsReportGaps, sub: "SKUs differ by more than 5%" },
        ]}
      />
      <HealthRows rows={[data.row]} />

      <section className="ia-section">
        <h3 className="ia-subtitle">Reports</h3>
        <div className="ia-card ia-scroll">
          <table className="ia-table ia-table--compact">
            <thead>
              <tr>
                <th>Report</th>
                <th>Last request</th>
                <th>Status</th>
                <th>Last fetched</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {data.reports.map((r) => (
                <tr key={r.key}>
                  <td>{r.reportType}</td>
                  <td>{dateTime(r.lastRequestedAt)}</td>
                  <td>
                    <Tag level={r.lastStatus === "FAILED" ? "crit" : r.lastStatus === "FETCHED" ? "ok" : "mute"}>
                      {(r.lastStatus || "none").replace("_", " ")}
                    </Tag>
                  </td>
                  <td>{dateTime(r.lastFetchedAt)}</td>
                  <td className="ia-muted">{r.error || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* <section className="ia-section">
        <div className="ia-toolbar">
          <h3 className="ia-subtitle">All stores</h3>
          <button type="button" className="ia-btn" onClick={loadAll} disabled={loadingAll}>
            {loadingAll ? "Loading…" : all ? "Reload all stores" : "Show all stores"}
          </button>
        </div>
        {error ? <div className="ia-alert">{error}</div> : null}
        {all ? <HealthRows rows={all.rows} /> : null}
      </section> */}
    </div>
  );
}
